import { parentesco } from '@utils';
import {
  casoUniaoEstavel,
  certidaoGenitor,
  childs,
  commons,
  convivente,
  deathOpcional,
  menorTutela,
  others,
  parentsParticipant,
  specialChild,
  spouses,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constants } = parentesco;

export const BeneficiarioRCMDocs = () => {
  const rules = {
    // deixar todos opcionais se acao for excluir
    anexoRG: dynamicRule('excluir'),
    anexoCPF: dynamicRule('excluir'),

    anexoCertidaoCasamentoOuNascimentoParticipante: dynamicRule('paisAdd'),
    anexoCertidaoCasamento: dynamicRule('casamentoAdd'),
    anexoCertidaoNascimento: dynamicRule('nascimentoAdd'),
    anexoLaudoMedico: dynamicRule('laudoMedicoBeneficiarioAdd'),

    anexoConvivente: dynamicRule('conviventeAdd'),
    anexoCasoUniaoEstavel: dynamicRule(),

    anexoCertidaoCasamentoGenitor: dynamicRule('enteadoAdd'),

    anexoTermoTutelaJudicial: dynamicRule('menorTutelaAdd'),

    anexoOutros: dynamicRule(),
  };

  const docs = {
    Excluir: [...deathOpcional],
    others: [...others],
    [constants.PAI]: [...commons, ...parentsParticipant],
    [constants.MAE]: [...commons, ...parentsParticipant],
    [constants.CONJUGE]: [...commons, ...spouses],
    [constants.FILHO]: [...commons, ...childs],
    [constants.FILHO_ESPECIAL]: [...commons, ...childs, ...specialChild],
    [constants.EX_CONJUGE]: [...commons, ...spouses],
    [constants.CONVIVENTE]: [...commons, ...convivente, ...casoUniaoEstavel],
    [constants.ENTEADO]: [...commons, ...childs, ...certidaoGenitor],
    [constants.MENOR_TUTELA]: [...commons, ...menorTutela],
    'Com invalidez': [...specialChild],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
